import type { BettyId } from "../../stores/BaseTypes";
import type { ImageSources } from "../../model/ArticleTypes";
import { UiTrackedButton } from "../common/TrackedComponents";
import * as React from "react";
import { DeleteItemConfirmationDialog } from "../common/DeleteConfirmationDialog";
import { trackStructured } from "../../utils/TrackingUtil";
type Props = {
	article: ItemView;
	isSideCaddy?: boolean | null;
	hasError?: boolean | null;
	onDeleteItem: (arg0: BettyId) => void;
};
type ItemView = {
	bundleId: string;
	description: string | null | undefined;
	imageSources: ImageSources;
};
export const ArticleBadgeDeleteButton: React.FC<Props> = ({ article, hasError, onDeleteItem }) => {
	const [showModalDelete, setShowModalDelete] = React.useState(false);

	const openDeleteItemModal = (): void => {
		setShowModalDelete(true);
		trackStructured("cart.item.delete.openDialog", {
			tags: {
				bettyBundleId: article.bundleId,
				mcw: "true",
			},
		});
	};

	const closeDeleteItemModal = (): void => {
		setShowModalDelete(false);
		trackStructured("cart.item.delete.cancel", {
			tags: {
				bettyBundleId: article.bundleId,
				mcw: "true",
			},
		});
	};

	const handleDeleteItem = (e?: React.MouseEvent): void => {
		if (e) {
			e.preventDefault();
		}

		onDeleteItem(article.bundleId);
		setShowModalDelete(false);
	};

	const handleDeleteOrOpenModal = hasError ? handleDeleteItem : openDeleteItemModal;

	return (
		<div className="oc-shopping-cart-item-delete article-actions-delete">
			<UiTrackedButton
				tags={{
					source: "ArticleBadgeDeleteButton.delete",
				}}
				className="btn-square test-shopping-cart-item-delete"
				onClick={handleDeleteOrOpenModal}
			>
				<span className="icon-lg icon-trash" />
			</UiTrackedButton>
			<DeleteItemConfirmationDialog
				show={showModalDelete}
				onCancel={closeDeleteItemModal}
				onDelete={handleDeleteItem}
				items={[article]}
			/>
		</div>
	);
};
